import axios from "./axios";
import api from "./api.mappings";
export class FormApi {
    /**
     * 表单加载
     * @param params
     */
    load(params) {
        return axios.get(api.form.load, {
            params
        });
    }
    /**
     * 暂存
     * @param params
     */
    save(params, path) {
        const url = path ? `${path}/save` : api.form.save;
        return axios.post(url, params);
    }
    /**
     * 提交
     * @param params
     */
    submit(params, path) {
        const url = path ? `${path}/submit` : api.form.submit;
        return axios.post(url, params);
    }
    /**
     * 删除业务表单
     * @param params
     */
    delete(params, path) {
        const url = path ? `${path}/delete` : api.form.delete;
        return axios.delete(url, {
            params
        });
    }
    /**
     * 检查工作项是否存在
     * @param workflowInstanceId
     */
    workItemExist(workflowInstanceId, ownerId) {
        return axios.get(api.form.workItemExist, {
            params: {
                workflowInstanceId,
                ownerId
            }
        });
    }
    /**
     * 获取催办记录列表
     */
    getUrgeList(instanceId) {
        return axios.get(api.form.getUrgeList, {
            params: {
                instanceId
            }
        });
    }
    /**
     * 保存催办消息
     * web端发送消息
     */
    saveDing(params) {
        return axios.post(api.form.saveDing, params);
    }
    /**
     * 获取待办用户id
     */
    getTodoUsers(instanceId) {
        return axios.get(api.form.getTodoUsers, {
            params: {
                instanceId
            }
        });
    }
    /**
     * 子表导入
     */
    importData(params) {
        return axios.post(api.form.importData, params);
    }
    /**
     * 子表导出
     */
    exportData(params) {
        return axios.post(api.form.exportData, params);
    }
    /**
     * 子表模板导出
     */
    exportTemplate(params) {
        return axios.post(api.form.exportTemplate, params);
    }
    /**
     * 获取表单短码
     */
    getShortCode(params) {
        return axios.get(api.form.getShortCode, {
            params
        });
    }
    /**
     * 更新子表排序
     */
    updateSortkey(params) {
        return axios.put(api.form.updateSortkey, params);
    }
    /**
     * 获取打印模板draftAttributesJson的接口
     */
    getPrintAttributesJson(params) {
        return axios.get(api.form.get, { params });
    }
    /*
     * @params {"htmlName": "文件名","htmlContent": "文件内容"}
     */
    toHtml(params) {
        return axios.post(api.form.toHtml, params);
    }
    /*
     * @params string htmlName为文件文件名，生成PDF文件
     */
    makePDF(params) {
        return axios.get(api.form.pdf, { params });
    }
    getMessageFormUrl(params) {
        return axios.get(api.form.getMessageFormUrl, {
            params
        });
    }
    /*
     * @params 获取关联表单title
     */
    getBizModelName(schemaCode) {
        return axios.get(api.form.getBizModelName, {
            params: {
                schemaCode
            }
        });
    }
    /**
     * @Author: Fan
     * @Description: 表单页提交时 的校验码获取接口, 当表单加载时或提交报错(除了重复提交错误)调用接口获取校验码
     * @URL:
     * @param {type}
     * @return:
     * @Date: 2020-01-09 17:18:41
     */
    getReplayToken(path) {
        const url = path ? `${path}/getReplayToken` : api.form.getReplayToken;
        return axios.get(url);
    }
    /**
     * 获取当前表单的流程节点数目
     */
    getWorkFlowNode(workflowInstanceId) {
        return axios.get(api.form.getWorkFlowNode, {
            params: {
                workFlowInstanceId: workflowInstanceId
            }
        });
    }
}
